import { render, staticRenderFns } from "./InvoiceGrid.vue?vue&type=template&id=63ec5900&"
import script from "./InvoiceGrid.vue?vue&type=script&lang=js&"
export * from "./InvoiceGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports